/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/*
 * Using this json only for 18F brand.
 */

const data = {
    title: 'My Order Is Not As Expected',
    description: '<p>Our goal is to help you connect, express and celebrate with the ones you love. We hope that your gift delivers a smile to the recipient but understand that sometimes things go awry.</p>'
    + '<p> Our local florists always put their passion and creativity into each gift. At times, they may need to make design substitutions to ensure your order is fresh and delivered in a timely manner. Please know that in this instance, the utmost care and attention is given so your gift is of equal value.</p>'
    + '<p>For flowers that are fresh from our growers, your flowers may arrive in bud form. This is to ensure freshness. Rest assured, with a little time and TLC, they will be in full bloom in a couple of days. For the best results, stems should be re-cut and placed in clean water along with the food provided.</p>',
    orderOptions: [
        {
            title: '',
            option: [
                {
                    title: 'What to expect when flowers arrive',
                    link: '/customer-service-help-videos',
                },
            ],

        },
    ],
    seo: {
        page_title: 'Customer Service Flowers',
    },
};
export default data;
